import React, { useState } from 'react';
type Status = 'idle' | 'sent';
export function ContactSection() {
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus('sent');
  };
  return <section id="contact" aria-labelledby="contact-heading" className="w-full bg-white py-20 md:py-28" data-id="element-39" data-mp="2piqej7aqum6h">
      <div className="mx-auto max-w-2xl px-6 md:px-12" data-id="element-40" data-mp="3d81iexne4wou">
        <div className="text-center" data-id="element-41" data-mp="3d68dpnwc8mjh">
          <h2 id="contact-heading" className="font-serif text-[1.9rem] leading-tight text-maroon md:text-[2.4rem]" data-id="element-42" data-mp="3i7xk2q8m8c18">
            Contact Us
          </h2>
          <p className="mt-4 font-sans text-[14px] font-light leading-relaxed text-maroon-soft" data-id="element-43" data-mp="388yfpjuvv2k1">
            Questions about a piece, a size, or a custom order? Write to us and
            we will reply personally.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="mt-10 space-y-5" data-id="element-44" data-mp="1wvmgxndzda4q">
          <div className="grid gap-5 sm:grid-cols-2" data-id="element-45" data-mp="7ld3mnrxge52">
            <div data-id="element-46" data-mp="7o94ajv5tgx7">
              <label htmlFor="contact-name" className="block font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-47" data-mp="2n1w4jp3ufq0">
                Name
              </label>
              <input id="contact-name" name="name" type="text" required className="mt-2 w-full border border-line bg-white px-4 py-3 font-sans text-[14px] font-light text-maroon outline-none transition-colors duration-150 ease-luxe placeholder:text-maroon-mute/60 focus:border-gold" placeholder="Your name" data-id="element-48" data-mp="ckpztz4ouxkb" />
            </div>
            <div data-id="element-49" data-mp="vc93m86jefne">
              <label htmlFor="contact-email" className="block font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-50" data-mp="vdtwzuh47sjo">
                Email
              </label>
              <input id="contact-email" name="email" type="email" required className="mt-2 w-full border border-line bg-white px-4 py-3 font-sans text-[14px] font-light text-maroon outline-none transition-colors duration-150 ease-luxe placeholder:text-maroon-mute/60 focus:border-gold" placeholder="you@email.com" data-id="element-51" data-mp="1yzmawqi9h8r" />
            </div>
          </div>

          <div data-id="element-52" data-mp="koz737fbca6d">
            <label htmlFor="contact-message" className="block font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-53" data-mp="kp8uqocvy58w">
              Message
            </label>
            <textarea id="contact-message" name="message" rows={5} required className="mt-2 w-full resize-none border border-line bg-white px-4 py-3 font-sans text-[14px] font-light text-maroon outline-none transition-colors duration-150 ease-luxe placeholder:text-maroon-mute/60 focus:border-gold" placeholder="How can we help?" data-id="element-54" data-mp="ulu41lvxu2ij" />
          </div>

          <div className="flex flex-col items-center gap-3 pt-2" data-id="element-55" data-mp="2o65gk09jpugm">
            <button type="submit" className="w-full bg-gold px-10 py-4 font-display text-[11px] font-light uppercase tracking-[0.3em] text-white transition-colors duration-150 ease-luxe hover:bg-gold-deep focus-visible:bg-gold-deep focus-visible:outline-none sm:w-auto" data-id="element-56" data-mp="2j7apyc5c71ly">
              Send message
            </button>
            <p role="status" aria-live="polite" className="min-h-[1.25rem] font-sans text-[12px] font-light text-maroon-mute" data-id="element-57" data-mp="36xer8cv1yp9s">
              {status === 'sent' ? 'Thank you — we have received your message and will reply shortly.' : ''}
            </p>
          </div>
        </form>
      </div>
    </section>;
}